import GameRule from "../model/config/GameRule"


const defaultGameRules:GameRule = {
	isNoCommision: false,
	isSuperSixSupported: true,
}

export default defaultGameRules
